import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyC2k1V7ymafqNRpWGOiHJCfrCFsrviOSnE",
  authDomain: "diversytoys-2828d.firebaseapp.com",
  projectId: "diversytoys-2828d",
  storageBucket: "diversytoys-2828d.firebasestorage.app",
  messagingSenderId: "163919422140",
  appId: "1:163919422140:web:1c1de9249c675e98cce6b9",
  measurementId: "G-S87LCPNC1H"
};

let app;
let auth;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { auth };
export default app;